let parseEvent = function (strDate) {
  let utcTmp;
  if (strDate) {
    utcTmp = new Date(strDate.replace(/-/g, '/'));
    return utcTmp;
  }
  return null;
};

let formatEvent = function (value, format) {
  if (!value) {
    return '';
  }
  if (!format) {
    format = 'yyyy/MM/dd';
  }
  let dateTemp;
  let date;
  switch (typeof value) {
    case 'string':
      if (value.indexOf('T') > -1) {
        dateTemp = value.substring(0, 19).replace(/-/g, "/").replace(/T/g, " ");
        date = new Date(dateTemp).getTime() + 1000 * 60 * 60 * 8;
        date = new Date(date);
      } else {
        dateTemp = value.substring(0, 19).replace(/-/g, "/").replace(/T/g, " ");
        date = new Date(dateTemp).getTime();
        date = new Date(date);
      }
      break;
    case 'number':
      date = new Date(value);
      break;
  }
  if (!(date instanceof Date)) {
    return;
  }
  let dict = {
    'yyyy': date.getFullYear(),
    'M': date.getMonth() + 1,
    'd': date.getDate(),
    'H': date.getHours(),
    'm': date.getMinutes(),
    's': date.getSeconds(),
    'MM': ('' + (date.getMonth() + 101)).substr(1),
    'dd': ('' + (date.getDate() + 100)).substr(1),
    'HH': ('' + (date.getHours() + 100)).substr(1),
    'mm': ('' + (date.getMinutes() + 100)).substr(1),
    'ss': ('' + (date.getSeconds() + 100)).substr(1)
  };
  return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function () {
    return dict[arguments[0]];
  });
};

let dateFilter = function (date, format) {
  return formatEvent(date, format || 'yyyy/MM/dd HH:mm');
};

export {dateFilter}



// WEBPACK FOOTER //
// ./common/filter.js